import styled from 'styled-components';

import PriceButton from 'components/Price/Button/container';

export default styled(PriceButton)`
  .btnWrapper {
    justify-content: center;
  }
`;
